/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { FullProduct } from '@msdyn365-commerce/commerce-entities';
import { ProductListLine } from '@msdyn365-commerce/retail-proxy';

/**
 * QuickOrderTemplateLine state information.
 */
export class QuickOrderTemplateLine {
    public productListLine: ProductListLine;

    public fullProduct?: FullProduct;

    public constructor(productListLine: ProductListLine, fullProduct?: FullProduct) {
        this.productListLine = productListLine;
        this.fullProduct = fullProduct;
    }
}

/**
 * Quick Order template line state.
 */
export interface IQuickOrderTemplateLinesState {
    lines: QuickOrderTemplateLine[];
    totalCount: number;
}
